import { LadiesMain } from "@modules/global/ladies-main"
import { resetSwiperAnimatingProperty } from "@modules/single-page/gallery/gallery-slider.ts"
import { galleryModal, isGalleryOpen } from "./gallery-elements"
import { initializeVideos, pauseVideos } from "./gallery-videos"

export function initializeModal(): void {
    const modal: HTMLElement | null = galleryModal()
    if (!modal) {
        return
    }

    const jqueryGalleryModal = $(modal)

    if (modal?.classList.contains("in")) {
        document.documentElement.classList.add("modal-open")
        initializeVideos()
    } else {
        jqueryGalleryModal.one("show.bs.modal", (): void => {
            document.documentElement.classList.add("modal-open")
            initializeVideos()
        })
    }

    jqueryGalleryModal.on("show.bs.modal", (): void => {
        resetSwiperAnimatingProperty()
        document.documentElement.classList.add("modal-open")
    })

    jqueryGalleryModal.on("hide.bs.modal", (): void => {
        document.documentElement.classList.remove("modal-open")
        LadiesMain.removeHashtagFromUrl("gallery")
        pauseVideos()
    })

    window.addEventListener("keyup", (event: KeyboardEvent): void => {
        if (event.key === "Escape" && isGalleryOpen()) {
            closeModal()
        }
    })
}

export function openModal(): void {
    const modal: HTMLElement | null = galleryModal()
    if (!modal) {
        return
    }

    requestAnimationFrame(() => {
        $(modal).modal("show")
    })
}

export function closeModal(): void {
    const modal: HTMLElement | null = galleryModal()
    if (!modal) {
        return
    }

    requestAnimationFrame(() => {
        $(modal).modal("hide")
    })
}
